import React, { useState, useEffect } from 'react';

import { loginApi, logoutApi, sessionApi, signUpApi } from '../services/AuthService';

const AuthContext = React.createContext({
  isLoggedIn: false,
  onLogout: () => {},
  onLogin: (email, password) => {},
  onSession: (token) => {},
  onSignUp: (username, email, password) => {}
});

export const AuthContextProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const storedUserLoggedInInformation = localStorage.getItem('isLoggedIn');

    if (storedUserLoggedInInformation === '1') {
      setIsLoggedIn(true);
    }
  }, []);

  const setSession = (data) => {
    localStorage.setItem('token', data.secret);
    localStorage.setItem('user_id', data.user.id);
    localStorage.setItem('isLoggedIn', '1');
    setIsLoggedIn(true);
  };

  const cleanSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false);
  };

  const handleLogout = async () => {
    const rest = await logoutApi(localStorage.getItem('token'))
      .then((data) => {
        if (data?.secret === localStorage.getItem('token')) {
          cleanSession();
        }
        return true;
      }).catch(() => {
        // TODO - I18n stuff?
        // TODO - Add something to handle error messages from the exceptions retrieved ...
        cleanSession();
        return false;
      });
    return rest;
  };

  const handleLogin = async (email, password) => {
    const rest = await loginApi(email, password)
      .then((data) => {
        if (!!data?.secret) {
          setSession(data);
          return true;
        } else if (!!data?.error) {
          cleanSession();
          return false;
        }
      }).catch((_e) => {
        // console.log(e.message)
        // TODO - I18n stuff?
        // TODO - Add something to handle error messages from the exceptions retrieved ...
        cleanSession();
        return false;
      });
    return rest;
  };

  const handleSession = async (token) => {
    const rest = await sessionApi(token)
      .then((data) => {
        if (!!data?.secret) {
          setSession(data);
        }
        return true;
      }).catch(() => {
        // TODO - I18n stuff?
        // TODO - Add something to handle error messages from the exceptions retrieved ...
        setLogout();
        return false;
      });
    return rest;
  };

  const handleSignUp = async (username, email, password) => {
    const rest = await signUpApi(username, email, password)
      .then((data) => {
        if (!!data?.secret) {
          setSession(data);
          return true;
        } else if (!!data?.error) {
          cleanSession();
          return false;
        }
      }).catch((_e) => {
        // console.log(e.message)
        // TODO - I18n stuff?
        // TODO - Add something to handle error messages from the exceptions retrieved ...
        cleanSession();
        return false;
      });
    return rest;
  };

  const setLogout = async () => {
    setIsLoggedIn(false);
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        onLogout: handleLogout,
        onLogin: handleLogin,
        onSession: handleSession,
        onSignUp: handleSignUp,
        onNoSession: setLogout
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
